import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LOCALE_QUERY_PARAMS, readLocaleFromSearch, useLanguage } from './LanguageContext';

/**
 * Adresteki ?lang=en / ?dil=en parametresini dil secimine uygular ve parametreyi
 * adresten siler (sayfa gecmisine yeni kayit eklemeden; diger parametreler ve
 * #bolum hash'i korunur).
 *
 * Eski en.tbhport.com adresi www.tbhport.com/?lang=en'e yonlendirildigi icin site
 * Ingilizce acilir. Parametre temizlenmezse kullanici TR'ye donup sayfayi
 * yeniledigine tekrar EN'e duserdi; secim zaten localStorage'da saklaniyor.
 * Uygulama ici gecislerde (ornek <Link to="/?lang=en">) de calisir.
 *
 * Not: react-router'in setSearchParams'i navigate("?...") cagirdigi icin hash'i
 * dusurur; bu yuzden navigate ile pathname + search + hash birlikte verilir.
 */
export function LocaleFromQuery() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();
  const { setLocale } = useLanguage();

  useEffect(() => {
    const requested = readLocaleFromSearch(search);
    if (!requested) return;
    setLocale(requested);
    const next = new URLSearchParams(search);
    LOCALE_QUERY_PARAMS.forEach((key) => next.delete(key));
    const remaining = next.toString();
    navigate({ pathname, search: remaining ? `?${remaining}` : '', hash }, { replace: true });
  }, [pathname, search, hash, navigate, setLocale]);

  return null;
}
